import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-user-success-with-invite',
  templateUrl: './register-user-success-with-invite.component.html',
  styleUrls: ['./register-user-success-with-invite.component.scss']
})
export class RegisterUserSuccessWithInviteComponent implements OnInit {

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor() { }

  ngOnInit(): void {
  }

}
